import { instructorsRoutes } from 'features/Instructors';
import { schedulesRoutes } from 'features/Schedules';
import { manageServicesRoutes } from 'features/ManageServices';
import { smartToolsRoutes } from 'features/SmartTools';

export default [...manageServicesRoutes, ...smartToolsRoutes, ...schedulesRoutes, ...instructorsRoutes];
